module.exports = __webpack_public_path__ + "media/ScanSuccess.660c50d9.mp3";